import { CheckCircle2 } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import MapEmbed from "../components/MapEmbed";

export default function About({ settings }) {
  const { t } = useI18n();
  const points = [t("about.point1"), t("about.point2"), t("about.point3"), t("about.point4"), t("about.point5"), t("about.point6")];

  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-16">
        <div className="overline">{t("about.overline")}</div>
        <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl mt-5 leading-none">
          {t("about.titleA")}<br /><span className="text-[#00A896]">{t("about.titleB")}</span>
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-16 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7 brut-card p-8 lg:p-12">
          <p className="text-[#C7CBD3] leading-relaxed text-base">{settings?.about}</p>
          <div className="mt-8 grid grid-cols-2 gap-4">
            {points.map((x) => (
              <div key={x} className="flex items-start gap-2 text-sm">
                <CheckCircle2 size={16} className="text-[#00A896] mt-0.5 shrink-0" />
                <span className="text-[#C7CBD3]">{x}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 grid grid-cols-1 gap-4">
          <div className="p-6 border border-[#00A896] bg-[#00A896] text-[#0A0B0E]">
            <div className="text-xs font-mono uppercase tracking-[0.3em]">{t("about.mission")}</div>
            <p className="font-display font-bold text-2xl mt-3 leading-tight">{t("about.missionText")}</p>
          </div>
          <div className="brut-card p-6">
            <div className="overline">{t("about.hq")}</div>
            <p className="text-[#C7CBD3] text-sm mt-3 leading-relaxed">{settings?.address}</p>
          </div>
          <div className="brut-card p-6">
            <div className="overline">{t("about.hours")}</div>
            <p className="text-[#C7CBD3] text-sm mt-3 leading-relaxed whitespace-pre-line">{t("about.hoursText")}</p>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <MapEmbed settings={settings} testid="about-map" />
      </section>
    </div>
  );
}
